import {Action} from './action.plugin';
import {ConditionPlugin} from './condition.plugin';
import {CreatureTypePlugin} from './creature-type.plugin';
import {CurrentLairsEffectsPlugin} from './current-lairs-effects.plugin';
import {DicePlugin} from './dice.plugin';
import {FeatPlugin} from './feat.plugin';
import {FeaturePlugin} from './feature.plugin';
import {ItemPlugin} from './item.plugin';
import {MagicItemPlugin} from './magic-item.plugin';
import {MonsterPlugin} from './monster.plugin';
import {SizePlugin} from './size.plugin';
import {SkillPlugin} from './skill.plugin';
import {SpellPlugin} from './spell.plugin';
import {TermPlugin} from './term.plugin';
import {BookPlugin} from './book.plugin';
import {BookChapterPlugin} from './book-chapter.plugin';
import {BookSectionPlugin} from './book-section.plugin';
import {StatblockPlugin} from './statblock.plugin';
import {ItemBlockPlugin} from './item-block.plugin';
import {WikiPlugin} from './wiki.plugin';
import {RulePlugin} from './rule.plugin';
import {SpeciePlugin} from './specie.plugin';
import {MarkdownPlugin} from './plugin';

export type {MarkdownPlugin} from './plugin';

export {
	Action,
	ConditionPlugin,
	CreatureTypePlugin,
	CurrentLairsEffectsPlugin,
	DicePlugin,
	FeatPlugin,
	FeaturePlugin,
	ItemPlugin,
	MagicItemPlugin,
	MonsterPlugin,
	SizePlugin,
	SkillPlugin,
	SpellPlugin,
	TermPlugin,
	BookPlugin,
	BookChapterPlugin,
	BookSectionPlugin,
	StatblockPlugin,
	ItemBlockPlugin,
	WikiPlugin,
	RulePlugin,
	SpeciePlugin,
};

/** Имя команды в тексте (`{@spell ...}`) → плагин, который её рисует */
export const markdownPlugins: Record<string, MarkdownPlugin> = {
	currentLairsEffects: CurrentLairsEffectsPlugin,
	item: ItemPlugin,
	'magic-item': MagicItemPlugin,
	dice: DicePlugin,
	spell: SpellPlugin,
	feat: FeatPlugin,
	feature: FeaturePlugin,
	term: TermPlugin,
	condition: ConditionPlugin,
	action: Action,
	creatureType: CreatureTypePlugin,
	size: SizePlugin,
	skill: SkillPlugin,
	monster: MonsterPlugin,
	book: BookPlugin,
	bookChapter: BookChapterPlugin,
	bookSection: BookSectionPlugin,
	statblock: StatblockPlugin,
	'item-block': ItemBlockPlugin,
	wiki: WikiPlugin,
	rule: RulePlugin,
	specie: SpeciePlugin,
};

/** Команды блочных плагинов: признак объявлен в самом плагине, здесь он только собирается вместе */
export function blockPluginNames(): string[] {
	return Object.keys(markdownPlugins).filter((name) => markdownPlugins[name].block);
}
